import type { Button } from '@modules/dynamic-form-builder/model/formBuilderInterface';

export const PURCHASE_POINTS_MODAL_TEXT = {
  TITLE: 'Purchase Points',
  SUBTITLE: 'Select Points Package'
} as const;

export const PURCHASE_POINTS_OPTION_BUTTON: Button = {
  type: 'button',
  class: 'btn btn-primary purchase-points-modal-option-button',
  label: ''
};
